import { palette } from '@jbhi-fi/lanyard-ui/themes';
import React, { ReactNode } from 'react';
import { ContentBlock } from '../ContentBlock';
import { HeroBanner, HeroBannerProps } from '../HeroBanner/HeroBanner';
import { ListingBlock } from '../ListingBlock';
import { styles } from './TakeoverBlock.css';

export type TakeoverBlockProps = {
  heading?: string;
  backgroundColor?: string;
  headingColor?: string;
  heroBanner: HeroBannerProps;
  carousel: ReactNode;
};

export const TakeoverBlock = ({
  heading,
  backgroundColor = palette.primary.main,
  headingColor = palette.primary.dark,
  heroBanner,
  carousel,
}: TakeoverBlockProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.background} style={{ background: backgroundColor }} />
      <ContentBlock maxWidth="large">
        <HeroBanner {...heroBanner} isContained={false} />

        <div className={styles.carousel}>
          <ListingBlock heading={heading} palette={{ heading: headingColor }}>
            {carousel}
          </ListingBlock>
        </div>
      </ContentBlock>
    </div>
  );
};
